import PropTypes from "prop-types";
import React, { useContext } from "react";
import RelativeLink from "app/pages/.shared/RelativeLink";
import "./moreProductBanner.scss";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/constants";
import IconExternalLink from "app/pages/.shared/IconExternalLink";
import Paragraphs from "app/pages/.shared/Paragraphs";
import { sendTagMoreProductBannerButtonClick } from "app/utils/analytics";

const IMG_SIZES = {
	large: { width: 1024, height: 135 },
	xlarge: { width: 1024, height: 135 },
	medium: { width: 1024, height: 135 },
};

const IMG_SIZES_SMALL = {
	small: { width: 710, height: 300 },
};

const CLOUDINARY_OPTIONS = ["c_fill"];

export const MoreProductBanner = props => {
	const { resolution } = useContext(AppGlobalsContext);

	const {
		desktopSrc,
		desktopThumbnail,
		mobileSrc,
		mobileThumbnail,
		message,
		ctaButtonText,
		ctaButtonColor,
		ctaButtonBackgroundColor,
		redirectUrl,
	} = props;

	const to = {
		pathname: redirectUrl,
	};

	const handleClick = () => {
		sendTagMoreProductBannerButtonClick();
	};

	return (
		<div className="more-product-banner">
			<p className="more-product-banner__content">
				{message.length > 0 && (
					<Paragraphs paragraphs={message} enableHTMLFormatting={true} />
				)}
			</p>
			<div className="more-product-banner__banner">
				<RelativeLink to={to} target="_blank" onClick={handleClick}>
					<ProgressiveImg
						sizes={resolution === RESOLUTION.SMALL ? IMG_SIZES_SMALL : IMG_SIZES}
						src={resolution === RESOLUTION.SMALL ? mobileSrc : desktopSrc}
						cloudinaryOptions={CLOUDINARY_OPTIONS}
						thumbnail={
							resolution === RESOLUTION.SMALL ? mobileThumbnail : desktopThumbnail
						}
					/>
				</RelativeLink>
				{ctaButtonText && (
					<div className="more-product-banner__cta">
						<RelativeLink
							target="_blank"
							style={{
								color: ctaButtonColor,
								backgroundColor: ctaButtonBackgroundColor,
							}}
							onClick={handleClick}
							to={to}
							design="primary"
						>
							{ctaButtonText} <IconExternalLink />
						</RelativeLink>
					</div>
				)}
			</div>
		</div>
	);
};

MoreProductBanner.propTypes = {
	desktopSrc: PropTypes.string,
	desktopThumbnail: PropTypes.string,
	mobileSrc: PropTypes.string,
	mobileThumbnail: PropTypes.string,
	message: PropTypes.array,
	ctaButtonText: PropTypes.string,
	ctaButtonColor: PropTypes.string,
	ctaButtonBackgroundColor: PropTypes.string,
	redirectUrl: PropTypes.string,
};

MoreProductBanner.defaultProps = {
	message: [],
};

export default MoreProductBanner;
